import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QUEUE_PAGE_SIZE } from "./hooks";

interface QueuePagerProps {
  /** A contagem REAL do servidor (FR-037) — nunca `items.length`. */
  total: number;
  offset: number;
  onOffsetChange: (offset: number) => void;
}

// Spec 077 (FR-037/FR-038) — a paginação das duas filas.
//
// ⚠️ A aba mostra o `total` do SERVIDOR. Sem este controle a tela dizia "Ações de calibração (60)"
// sobre uma lista de 25, e as outras 35 não tinham caminho nenhum — e como a ordem é a mais antiga
// primeiro, o que ficava invisível era sempre o trabalho recém-chegado. Uma contagem confiável
// acima de uma lista truncada em silêncio é pior que uma contagem errada: ela convence.
//
// O intervalo vem escrito ("26–50 de 60") de propósito: é o que responde, sem contar linhas, se o
// que está na tela é tudo ou é um pedaço.

export function QueuePager({ total, offset, onOffsetChange }: QueuePagerProps) {
  if (total <= QUEUE_PAGE_SIZE) return null;

  const first = offset + 1;
  const last = Math.min(offset + QUEUE_PAGE_SIZE, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pt-1">
      <p className="text-[12px] tabular-nums text-text-secondary">
        {first}–{last} de {total}
      </p>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="outline"
          disabled={offset === 0}
          onClick={() => onOffsetChange(Math.max(0, offset - QUEUE_PAGE_SIZE))}
        >
          <ChevronLeft className="h-4 w-4" aria-hidden />
          Anteriores
        </Button>
        <Button
          size="sm"
          variant="outline"
          disabled={last >= total}
          onClick={() => onOffsetChange(offset + QUEUE_PAGE_SIZE)}
        >
          Próximas
          <ChevronRight className="h-4 w-4" aria-hidden />
        </Button>
      </div>
    </div>
  );
}
